var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smart-link',{staticClass:"menu-item body",attrs:{"to":_vm.link.href,"data-gtm":"TopNav.Link"}},[_vm._v(_vm._s(_vm.link.title))])}
var staticRenderFns = []

export { render, staticRenderFns }